import React from "react";

import { Person } from "@mui/icons-material";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";

const Notification = ({ data, getNotificationIcon, getTypeColor }) => {
  return (
    <div>
      {data?.map((notification, index) => (
        <div
          key={index}
          className={`py-4 px-5 hover:bg-gray-50 transition-colors duration-150 cursor-pointer relative ${
            notification.isNew && ""
          }`}
        >
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              {getNotificationIcon(notification.type)}
            </div>

            <div className="flex-1 min-w-0">
              {" "}
              <span
                className={`inline-block px-2 py-1 text-xs font-medium rounded-full border mb-2 ${getTypeColor(
                  notification.type
                )}`}
              >
                {notification.type}
              </span>
              <p
                className={`text-sm mb-2 ${
                  notification.isNew
                    ? "font-medium text-gray-900"
                    : "text-gray-700"
                }`}
              >
                {notification.text}
              </p>
              <div className="text-xs text-gray-500">
                <div className="flex items-center  truncate">
                  <Person className="!w-4 !h-4" />
                  <span className="mt-[-3px]">From: {notification.publisher}</span>
                </div>
                <div className="flex items-center space-x-1 flex-shrink-0 mt-3">
                  <QueryBuilderIcon className="!w-4 !h-4" />
                  <span className="mt-[-5px]">
                    {notification.timeStampDisplayText}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Notification;
